// extracted by mini-css-extract-plugin
export default {"BreadCrumbLink":"Q8yLyF4rkm4HylW_KMhs"};